import React, { MouseEventHandler, useState } from 'react';
import router from 'next/router';
import { css } from '@linaria/core';
import { Clickable } from 'reakit';
import { IconExpandDownRounded, IconExpandUpRounded, IconSettingsTwo } from 'components/Icons';
import { usePopoverState, PopoverAction, Popover } from 'components/Popover';
import { ModelSettings } from 'components/ModelOutputRenderer/components/CollapsibleBar/components/ModelSettings';
import { MODES_HEIGHT } from 'styles/constants';
export interface CollapsibleBarProps {
  modelId?: string;
  modelIdLink?: string;
  children: React.ReactNode;
  isModelVersionsDropdownVisible: boolean;
  isThresholdSliderVisible: boolean;
  isBarCollapsed?: boolean;
  minThreshold: number;
  setMinThreshold: (num: number) => void;
}
export const CollapsibleBar = (props: CollapsibleBarProps): JSX.Element => {
  const {
    modelId,
    modelIdLink,
    children,
    isModelVersionsDropdownVisible,
    isThresholdSliderVisible,
    isBarCollapsed = false,
    minThreshold,
    setMinThreshold
  } = props;
  const [isDrawerOpen, setDrawerOpen] = useState<boolean>(!isBarCollapsed);
  const settingsPopover = usePopoverState({
    placement: 'bottom-start'
  });
  const isModelSettingsEnabled = isThresholdSliderVisible;
  const toggleDrawerState = (): void => {
    setDrawerOpen(!isDrawerOpen);
  };
  const handlePopoverButtonClick = ((e => {
    e.stopPropagation();
  }) as MouseEventHandler<HTMLElement>);
  const ModelIdTitle = modelIdLink ? <button type="button" className="model-title" onClick={() => router.push(modelIdLink)}>
      {modelId}
    </button> : <>{modelId}</>;
  return <div className={collapsibleBarStyles}>
      <button type="button" className="bar-header" onClick={toggleDrawerState}>
        <div className="title">{isModelVersionsDropdownVisible ? 'Summary' : ModelIdTitle}</div>
        <div className="action-buttons">
          {/* Display model settings only if threshold slider needed since there are no other settings for now */}
          {isModelSettingsEnabled && <Clickable as="div" className="header-icon" onClick={handlePopoverButtonClick}>
              <PopoverAction popover={settingsPopover}>
                <IconSettingsTwo size={18} data-testid="workflow-settings-icon" />
              </PopoverAction>
            </Clickable>}
          <div className="header-icon">
            {isDrawerOpen ? <IconExpandDownRounded data-testid="expand-down" size={12} /> : <IconExpandUpRounded data-testid="expand-up" size={12} />}
          </div>
        </div>
      </button>
      <Popover popover={settingsPopover} className="popover" aria-label="Settings popup">
        <ModelSettings isThresholdSliderVisible={isThresholdSliderVisible} minThreshold={minThreshold} setMinThreshold={setMinThreshold} />
      </Popover>
      {isDrawerOpen && <div className="bar-content">{children}</div>}
    </div>;
};
const collapsibleBarStyles = "omponents__ModelOutputRenderer__components__CollapsibleBar__CollapsibleBar_tsx-collapsibleBarStyles-c1e98fpz";

require("./CollapsibleBar.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./CollapsibleBar.tsx");